import {MISBookingMode} from "./TRMISBookingMode";
import PlatformDetector from "./PlatformDetector";

import axios  from "axios";

export const sendEventTobackend = async  (eventName, eventValue , eventFrom )  =>{
    console.log("Its Called the send back end data ");
    const TrviaAndMisData = MISBookingMode();
      let deviceId = null;
      let deviceDaySession = null
      let mobileNumber = "";

      if (
            PlatformDetector.isAndroidWebView() ||     PlatformDetector.isIOSWebView()
          ){
      
             if(window.RegistrationUniqueIDFromMobile ){
                    deviceId =window.RegistrationUniqueIDFromMobile;
                }
          
                if(window.SessionUniqueIDFromMobile){
                   deviceDaySession = {sessionId:window.SessionUniqueIDFromMobile}; 
                }
      
          }else{
                if(window.SessionConstants.DEVICE_INFO_KEY ){
                    deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
                }
          
                if(window.SessionConstants.DEVICE_SESSION_KEY){
                   deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
                }
          }

      // if(window.SessionConstants.DEVICE_INFO_KEY ){
      //     deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
      // }

      // if(window.SessionConstants.DEVICE_SESSION_KEY){
      //    deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
      // }
       
      if(deviceId != null && deviceDaySession != null){


          
        console.log(eventName);
        console.log(toSafeString(eventValue));
        console.log(eventFrom);
        console.log(deviceId);
        console.log(deviceDaySession);



        console.log(window.__APP_STATE__);

      
      if(window.__APP_STATE__){

        if(window.__APP_STATE__?.IsPassengerSignedIn != 0){
        console.log("IN side Not Null");
        console.log(window.__APP_STATE__.SignedPassenger);
        mobileNumber = window.__APP_STATE__.SignedPassenger.MobileNumber;
        }else{
        console.log(window.__APP_STATE__.SignedPassenger);
        }
      }



      

      


      const payload = {
        RegistrationUniqueID : deviceId,
        SessionUniqueID :deviceDaySession.sessionId,
        MobileNumber : mobileNumber,
        EventName : toSafeString(eventName),
        TRVia : TrviaAndMisData.deviceType
      }


      console.log("Its Called the send back end data ");


      console.log(payload)


      const response = await axios.post('/send-event-to-backend', payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log(response);     
      
      
      
      
      }else{


         console.log("Device Id Is Null or session Id is null");

      }
      
      
      
      

}



  function toSafeString(value) {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  try {
    return JSON.stringify(value);
  } catch (e) {
    return String(value);
  }
}